import Vue from 'vue'
import VueRouter from 'vue-router'
//VIEWS
import Sessions from '../views/Sessions.vue'
import Dashboard from '../views/Dashboard.vue'

//COMPONENTS
import Login from '../components/login/Login.vue'
import OinkList from '../components/oink-list/OinkList.vue'
import OinkReports from '../components/oink-reports/OinkReports.vue'
Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      component: Sessions,
      children: [
        {
          path: '',
          name: 'Ingreso',
          component: Login
        }
      ]
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'OinkList',
          component: OinkList,
        },
        {
          path: 'detail/:id/:name',
          name: 'OinkList',
          component: OinkReports,
        }
      ]
    },
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

export default router
